import React, { createContext, ReactElement, ReactNode, useContext } from 'react';
import { Option } from 'fp-ts/lib/Option';
import { ErrorData } from 'domain/types';
import Layout from 'domain/entity/layout';
import { CriteriaCallback, useCase } from 'adapter/in/common/hooks/useCase';
import { ReadLayouts } from 'use-case/layout/read/readLayoutsUseCase';
import { UpdateLayout } from 'use-case/layout/update/updateLayoutUseCase';

// Move to common place
export type MaybeError = Option<ErrorData>;
export type MaybeLayout = Option<Layout>;
export type MaybeLayouts = Option<Layout[]>;

export type LayoutsReadData = {
    read: CriteriaCallback;
    readIsLoading: boolean;
    readResult: MaybeLayouts;
    readError: MaybeError;
    readReset: () => void;
    update: CriteriaCallback;
    updateIsLoading: boolean;
    updateResult: MaybeLayout;
    updateError: MaybeError;
    updateReset: () => void;
};
export type LayoutsProvider = {
    readLayouts: ReadLayouts;
    updateLayout: UpdateLayout;
    children: ReactNode;
};

export const LayoutsContext = createContext({} as LayoutsReadData);

export const useLayouts = (): LayoutsReadData => useContext(LayoutsContext);

export const LayoutsProvider = (props: LayoutsProvider): ReactElement => {
    const { children, readLayouts, updateLayout } = props;

    const { isLoading: readIsLoading, data: readResult, error: readError, execute: read, reset: readReset } = useCase(readLayouts, false);
    const { isLoading: updateIsLoading, data: updateResult, error: updateError, execute: update, reset: updateReset } = useCase(
        updateLayout,
        false
    );

    return (
        <LayoutsContext.Provider
            value={{
                read,
                readIsLoading,
                readResult,
                readError,
                readReset,
                update,
                updateIsLoading,
                updateResult,
                updateError,
                updateReset,
            }}
        >
            {children}
        </LayoutsContext.Provider>
    );
};
